import { useConfig } from '@occc/config';
import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { ChipList } from '../../../components';

const DEF_SUB_BRAND_CHIP_LIST = [{ label: 'Universal' }];

export const SubBrandConstraint = ({ constraints }: { constraints: ConstraintFragment[] }) => {
  const { config } = useConfig();
  const cst = getConstraintsByType('ConstraintSubBrand', constraints);
  const subBrandIds = [...new Set(cst.flatMap((c) => c.subBrandUuids))];

  const subBrandsList = config.subBrands?.list || [];
  const subBrandChips = subBrandIds.map((id) => {
    const subBrand = subBrandsList.find((item) => item.uuid === id);
    return { label: subBrand?.name || id };
  });

  return (
    <ChipList
      label='Sub Brand'
      items={subBrandChips.length ? subBrandChips : DEF_SUB_BRAND_CHIP_LIST}
    />
  );
};
